export let AsyncStatus;
(function (AsyncStatus) {
  AsyncStatus["FAILED"] = "FAILED";
  AsyncStatus["INITIAL_FETCH_LOADING"] = "INITIAL_FETCH_LOADING";
  AsyncStatus["PAGINATED_FETCH_LOADING"] = "PAGINATED_FETCH_LOADING";
  AsyncStatus["PREFETCH"] = "PREFETCH";
  AsyncStatus["SUCCEEDED"] = "SUCCEEDED";
  AsyncStatus["UNINITIALIZED"] = "UNINITIALIZED";
})(AsyncStatus || (AsyncStatus = {}));